import { createChart, LineData } from 'lightweight-charts';
import React, { useEffect, useRef } from 'react';
import { baseChartStyle, sparkLineStyle } from '../../common/chartsConfig';
import styled, { useTheme } from 'styled-components';
import { useTestId } from '../../hooks/useTestId';
import { getTradingColour } from '../../common/utils';
import { Align } from '../../common/align';

export interface ISparkProps {
  data?: LineData[];
  lineWidth?: 3 | 1 | 2 | 4;
  align?: Align.Left | Align.Right;
  priceLineHidden?: boolean;
}

export const Container = styled.div`
  display: inline-block;
  width: 5rem;
  height: 2rem;
`;

export const Spark: React.FC<ISparkProps> = ({ data, align = Align.Right, priceLineHidden = false, lineWidth = 3, ...rest }) => {
  const ref = useRef() as React.MutableRefObject<HTMLDivElement>;
  const theme = useTheme();
  const { generateTestId } = useTestId(rest, 'Spark');

  useEffect(() => {
    const chart = createChart(ref.current, {
      ...baseChartStyle
    });
    const lineSeries = chart.addLineSeries();

    if (data?.length) {
      lineSeries.applyOptions({
        ...sparkLineStyle,
        color: theme.colours.trading[getTradingColour(data)],
        lineWidth,
        priceLineVisible: !priceLineHidden
      });
      lineSeries.setData(data);

      chart.timeScale().applyOptions({ fixLeftEdge: align === Align.Left });
    }

    return () => {
      chart.remove();
    };
  }, [data, lineWidth, align, priceLineHidden]);

  return <Container ref={ref} {...generateTestId()} {...rest} />;
};
